// src/constants/sidebarItems.js
import {
    Dashboard,
    Category,
    AccountTree,
    WorkspacePremium,
    LocalOffer,
    Description,
    ViewQuilt,
    Article,
    Tune,
    Inventory,
    CollectionsBookmark,
    Person,
} from "@mui/icons-material";


export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },
    {
        key: 'departments',
        label: { en: 'Departments', ar: 'الأقسام' },
        path: '/departments',
        icon: AccountTree,
    },
    {
        key: 'categories',
        label: { en: 'Categories', ar: 'الفئات' },
        path: '/categories',
        icon: Category,
    },
    {
        key: 'brands',
        label: { en: 'Brands', ar: 'العلامات التجارية' },
        path: '/brands',
        icon: WorkspacePremium,
    },
    {
        key: 'tags',
        label: { en: 'Tags', ar: 'الوسوم' },
        path: '/tags',
        icon: LocalOffer,
    },
    {
        key: 'option-groups',
        label: { en: 'Option Groups', ar: 'مجموعات الخيارات' },
        path: '/option-groups',
        icon: Tune,
    },
    {
        key: 'products',
        label: { en: 'Products', ar: 'المنتجات' },
        path: '/products',
        icon: Inventory,
    },
    {
        key: 'collections',
        label: { en: 'Collections', ar: 'المجموعات' },
        path: '/collections',
        icon: CollectionsBookmark,
    },
    {
        key: 'pages',
        label: { en: 'Pages', ar: 'الصفحات' },
        path: '/pages',
        icon: Description,
    },
    {
        key: 'home-sections',
        label: { en: 'Home Sections', ar: 'أقسام الصفحة الرئيسية' },
        path: '/home-sections',
        icon: ViewQuilt,
    },
    {
        key: 'blog',
        label: { en: 'Blog', ar: 'المدونة' },
        icon: Article,
        children: [
            {
                key: 'posts',
                label: { en: 'All Posts', ar: 'كل المقالات' },
                path: '/blog/posts',
            },
            {
                key: 'post-categories',
                label: { en: 'Categories', ar: 'التصنيفات' },
                path: '/blog/categories',
            },
            {
                key: 'post-tags',
                label: { en: 'Tags', ar: 'الوسوم' },
                path: '/blog/tags',
            },
        ],
    },
    {
        key: 'profile',
        label: { en: 'Profile', ar: 'الملف الشخصي' },
        path: '/profile',
        icon: Person,
    },
];